/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * NOTE: this directive requires the Google script in the base template to load the Google Maps JS
 * API before this directive is initialized.
 *
 * @module enervee_utils.google_maps
 */
function googleMapsDirective() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            control: '=',
            isDirectionMap: '=',
            startCoordinates: '=',
            endCoordinates: '='
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: googleMapsController,
        link: function(scope, element, attrs) {
            scope.internalControl = scope.control || {};
            scope.internalControl.renderDirection = function() {};
        },
        template: require('./googleMapsView.html')
    };
}

googleMapsController.$inject = [
    '$log',
    '$element',
    '$q',
    '$window',
    'UtilService'
];

function googleMapsController(
    $log,
    $element,
    $q,
    $window,
    UtilService
) {

    this.$onInit = function () {
        let vm = this,
            directionsService,
            directionsDisplay,
            stepDisplay,
            map;

        vm.control = vm.control || {};

        vm.distanceDisplay = "";
        vm.distanceValueInMeters = null;
        vm.control = vm.control || {};
        vm.mapStyles = {};

        /**
         * Initializes google maps based on the given coordinates and options
         *
         * @param {Object} locationCoordinates
         * @param {String} locationCoordinates.lat - latitude of the given location
         * @param {String} locationCoordinates.long - longitude of the given location
         * @param {Object} mapOptions - google map options
         */
        vm.control.initialMap = function (locationCoordinates, mapOptions) {
            let lat = parseFloat(UtilService.getSiteSetting('default_utility_lat', 0));
            let lng = parseFloat(UtilService.getSiteSetting('default_utility_lng', 0));

            if (locationCoordinates) {
                lat = locationCoordinates.lat;
                lng = locationCoordinates.long;
            }

            const coordinates = new $window.google.maps.LatLng(lat, lng);

            const defaultGoogleMapsOptions = {
                zoom: 13,
                center: coordinates,
                fullscreenControl: false,
            };
            vm.control.coordinates = coordinates;

            const defaultMapOptions = UtilService.getSiteSetting('default_google_maps_options', defaultGoogleMapsOptions);

            let finalMapOptions = defaultMapOptions;
            if (mapOptions) {
                finalMapOptions = $.extend({}, defaultMapOptions, mapOptions || {});
            }

            const googleMaps = $($element.find('.google-maps-map'))[0];
            vm.control.map = new google.maps.Map(googleMaps, finalMapOptions);

            setTimeout(function () {
                vm.mapStyles = {"position": ""};
            }, 1000);
        };

        /**
         * initialDirectionMap is a control function which will render the map centered at the given google.maps.LatLng
         * coordinates with the give map options (if any)
         *
         * @param locationCoordinates the google.maps.LatLng coordinate of the center of the map
         * @param mapOptions the dictionary of google map options
         * {
         *      zoom: 8,
         *      center: new google.maps.LatLng(lat, lng),
         *      scaleControl: false,
         *      zoomControl: true,
         *      mapTypeControl: false,
         *      fullscreenControl: true,
         *      rotateControl: false,
         *      streetViewControl: false
         *  }
         */
        vm.control.initialDirectionMap = function(locationCoordinates, mapOptions) {
            /**
             * Accessing `google` as a property of `$window` because it's attached to the
             * `window` global by its script in the base template.
             */
            directionsService = new $window.google.maps.DirectionsService();

            let defaultCoordinates = locationCoordinates;

            if (!locationCoordinates) {
                const defaultLat = parseFloat(UtilService.getSiteSetting('default_utility_lat', 0));
                const defaultLong = parseFloat(UtilService.getSiteSetting('default_utility_lng', 0));

                defaultCoordinates = new $window.google.maps.LatLng(defaultLat, defaultLong);
            }

            const defaultGoogleMapsOptions = {
                zoom: 13,
                center: defaultCoordinates,
                scaleControl: false,
                zoomControl: false,
                mapTypeControl: false,
                fullscreenControl: false,
                rotateControl: false,
                streetViewControl: false
            };

            const defaultMapOptions = UtilService.getSiteSetting('default_google_maps_options', defaultGoogleMapsOptions);

            let finalMapOptions = defaultMapOptions;
            if (mapOptions) {
                finalMapOptions = $window.$.extend({}, defaultMapOptions, mapOptions || {});
            }

            map = new $window.google.maps.Map($window.$($element.find('.google-maps-map'))[0], finalMapOptions);

            // Create a renderer for directions and bind it to the map.
            const rendererOptions = {
                map: map
            };
            directionsDisplay = new $window.google.maps.DirectionsRenderer(rendererOptions);

            // Instantiate an info window to hold step text.
            stepDisplay = new $window.google.maps.InfoWindow();
        };

        /**
         * renderDirection is a control function which will render the given google.maps.LatLng coordinates
         *
         * @param start the google.maps.LatLng coordinate of the point A
         * @param end the google.maps.LatLng coordinate of the point B
         */
        vm.control.renderDirection = function(start, end) {
            let deferred = $q.defer();

            const request = {
                origin: start,
                destination: end,
                travelMode: 'DRIVING'
            };

            directionsService.route(request, function (response, status) {
                if (status === "OK") {
                    directionsDisplay.setDirections(response);

                    try {
                        const distance = response.routes[0].legs[0].distance;

                        vm.distanceDisplay = distance.text;
                        vm.distanceValueInMeters = distance.value;

                        deferred.resolve({'full_response': response, 'distance_value': vm.distanceValueInMeters});
                    } catch (e) {
                        $log.warn("There was a problem with extracting routing values of the given direction.");
                        deferred.reject({});
                    }
                } else {
                    deferred.reject({});
                }
            });

            return deferred.promise;
        };

    };
}

module.exports = googleMapsDirective;
